
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isCartUpsell = this.dataset.isCartUpsell === 'true';
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    // Cart drawer upsells call handleSubmit without a browser submit event.
    handleSubmit(evt) {
      return this.onSubmitHandler(evt);
    }

    includePreselectedCartUpsells(formData) {
      if (!this.cart || this.isCartUpsell) return;

      const selectedIds = [];
      this.cart
        .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
        .forEach((upsell) => {
          if (
            upsell.dataset.selected === 'true' &&
            upsell.dataset.id &&
            !this.cart.querySelector(`.cart-item--product-${upsell.dataset.handle}`)
          ) {
            selectedIds.push(String(upsell.dataset.id));
          }
        });

      if (selectedIds.length === 0) return;

      const itemKeyPattern = /^items\[(\d+)\]\[id\]$/;
      const existingItemIds = new Set();
      let nextIndex = 0;

      for (const [key, value] of formData.entries()) {
        const match = key.match(itemKeyPattern);
        if (!match) continue;
        existingItemIds.add(String(value));
        nextIndex = Math.max(nextIndex, Number(match[1]) + 1);
      }

      const primaryVariantId = formData.get('id');
      if (nextIndex === 0 && primaryVariantId) {
        const quantity = formData.get('quantity') || '1';
        formData.set('items[0][id]', primaryVariantId);
        formData.set('items[0][quantity]', quantity);
        existingItemIds.add(String(primaryVariantId));

        for (const [key, value] of [...formData.entries()]) {
          if (key.startsWith('properties[')) {
            formData.set(`items[0][${key}]`, value);
            formData.delete(key);
          }
        }

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) formData.set('items[0][selling_plan]', sellingPlan);
        nextIndex = 1;
      }

      formData.delete('id');
      formData.delete('quantity');
      formData.delete('selling_plan');

      selectedIds.forEach((id) => {
        if (existingItemIds.has(id)) return;
        formData.set(`items[${nextIndex}][id]`, id);
        formData.set(`items[${nextIndex}][quantity]`, '1');
        existingItemIds.add(id);
        nextIndex += 1;
      });
    }

    onSubmitHandler(evt) {
      if (evt) evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const loadingSpinner = this.querySelector('.loading-overlay__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
    
      //Added to generate selling plan add to cart response
      const sellingPlanId = typeof window.getCurrentSellingPlanId === 'function'
        ? window.getCurrentSellingPlanId()
        : '';
      if (sellingPlanId) formData.append('selling_plan', sellingPlanId);

      const primaryVariantId = formData.get('id');
      this.includePreselectedCartUpsells(formData);
      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: primaryVariantId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: primaryVariantId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
